import { IndexedFilters } from '@/catalog/types/filters';
import { cn } from '@/shadcn-ui/utils';
import { Button } from '@/shadcn-ui/button';
import FilterPills from './filter-pills/filter-pills';
import FilterAccordion from './filter-accordion/filter-accordion';
import { InventoryFiltersResponse } from '@/catalog/hooks/use-inventory-filters';
import { FilterCounts } from '@/catalog/types/catalog-market-loader';

interface SidePanelFiltersProps extends InventoryFiltersResponse {
  filterOptions: IndexedFilters;
  filterCounts?: FilterCounts;
  selectedPlanMileage?: number;
  canViewSwap?: boolean;
  vehicleWaitlistEnabled?: boolean;
  waitlistLinkPrefix?: string;
  defaultAccordionValue?: string[];
}

/**
 * Side panel with inventory filters. This component is only displayed for desktop.
 */
export default function SidePanelFilters({
  filterOptions,
  selectedFilters,
  setSelectedFilters,
  handleClearAll,
  hasNoFilters,
  filterCount,
  filterCounts,
  selectedPlanMileage,
  canViewSwap,
  vehicleWaitlistEnabled = false,
  waitlistLinkPrefix,
  defaultAccordionValue,
}: SidePanelFiltersProps) {
  return (
    <div className="sticky top-[32px] hidden h-fit max-h-[calc(100vh-64px)] w-[286px] flex-shrink-0 flex-col rounded-[16px] border border-flexcar-neutral80 lg:flex">
      <div
        className={cn(
          'flex flex-col gap-[16px] rounded-t-[16px] bg-flexcar-neutral90 p-[24px]',
          {
            'rounded-b-[16px]': Object.keys(filterOptions).length === 0,
            'rounded-b-none': Object.keys(filterOptions).length !== 0,
          }
        )}
      >
        <div className="flex flex-row items-center justify-between">
          <p className="body2-strong text-flexcar-neutral1">
            Filters{filterCount > 0 ? ` (${filterCount})` : ''}
          </p>
          <Button
            variant="clear"
            onClick={handleClearAll}
            disabled={hasNoFilters}
            className="h-auto"
          >
            <p
              className={cn('body3-strong', {
                'text-flexcar-blue40': !hasNoFilters,
                'text-flexcar-neutral70': hasNoFilters,
              })}
            >
              Clear all
            </p>
          </Button>
        </div>
        {!hasNoFilters ? (
          <FilterPills
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        ) : null}
      </div>

      <FilterAccordion
        filterOptions={filterOptions}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        filterCounts={filterCounts}
        selectedPlanMileage={selectedPlanMileage}
        canViewSwap={canViewSwap}
        vehicleWaitlistEnabled={vehicleWaitlistEnabled}
        waitlistLinkPrefix={waitlistLinkPrefix}
        defaultAccordionValue={defaultAccordionValue}
      />
    </div>
  );
}
